import { useParams } from "react-router-dom";
import { StoryblokComponent, useStoryblok } from "@storyblok/react";
import Preloader from "components/GlobalPreloader/Preloader";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";

const BlogArticlePage = () => {
  const { category, slug } = useParams();
  const { i18n } = useTranslation();
  const locale = i18n.language;
  const story = useStoryblok(`${category}/${slug}`, { version: "draft", language: locale });
  const fullSlug = story.full_slug || "";
  const slugWithoutLocale = fullSlug.startsWith("en/") ? fullSlug.slice(3) : fullSlug;
  const seo = story?.content?.seo;
  const main_image = story?.content;

  if (!story?.content) {
    return (
      <Preloader
        customStyles={{
          position: "absolute",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          padding: "0",
          margin: "0",
          border: 0,
          background: "rgba(255, 255, 255, 0.6)",
        }}
      />
    );
  }
  return (
    <>
      <Helmet>
        <link rel="canonical" href={`https://ducksay-pwa.com/blog/${locale === "en" ? fullSlug : `ru/${fullSlug}>`}`} />
        <link rel="alternate" hrefLang="ru" href={`https://ducksay-pwa.com/blog/ru/${slugWithoutLocale}`} />
        <link rel="alternate" hrefLang="en" href={`https://ducksay-pwa.com/blog/en/${slugWithoutLocale}`} />
        <link rel="alternate" hrefLang="x-default" href={`https://ducksay-pwa.com/blog/ru/${slugWithoutLocale}`} />
        {seo?.title && <meta name="title" content={seo.title} />}
        {seo?.description && <meta name="description" content={seo.description} />}
        <meta property="og:image" content={main_image.filename} />
        <meta property="og:title" content={seo?.title} />
        <meta property="og:description" content={seo?.description} />
        <meta property="og:type" content="article" />
      </Helmet>
      <StoryblokComponent blok={story.content} />
    </>
  );
};

export default BlogArticlePage;
